import { findByUuid } from '@ps/bridge/qc/node/utils'
import { addChildAt } from '@ps/bridge/qc/node'
import store from '@ps/store'
import qc from 'qc'
import * as videoScript from '@ps/bridge/qc/scripts/video'
import { VideoScript } from '@ps/bridge/qc/scripts/video'
import _ from 'lodash'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { EditorDataScript } from '@ps/bridge/qc/scripts/editor'
import { isIvPage } from '@ps/router/config'
import { Event, EventBus } from '@ps/utils/event-bus'
export type AddVideoActionValue = {
  newValue: {
    node: qc.Node
    parent: qc.Node
    index: number
    ivNewNodes?: qc.Node[]
    ivNewAst?: editorScript.AstEventItem[]
  }
  oldValue: {
    node: qc.Node
    activeUuid: string
    ivNodes?: qc.Node[]
    ivAst?: editorScript.AstEventItem[]
  }
}
export const getAddVideoAction = (value: AddVideoActionValue) => {
  return {
    execute: async ({ newValue }: AddVideoActionValue) => {
      const { node, parent, index, ivNewNodes, ivNewAst } = newValue
      if (!findByUuid(node.uuid)) {
        addChildAt({
          node,
          parent,
          index,
        })
      }
      const currentSceneNode =
        store.state.workspace.sceneManager.currentSceneNode
      if (isIvPage()) {
        // 互动视频场景添加完视频后设置为未编辑状态
        currentSceneNode.hasEditThisTime = false
      }
      if (ivNewNodes) {
        currentSceneNode.removeChildren()
        ivNewNodes.forEach((node) => {
          currentSceneNode.addChild(node)
        })
        const ped = editorScript.getScript(currentSceneNode) as EditorDataScript
        ped.vpAst = _.cloneDeep(ivNewAst)
      }
      store.dispatch('workspace/game/video/setVideosManager')
      store.dispatch('workspace/game/updateActiveNode', {
        node,
        record: false,
      })
      EventBus.$emit(Event.IV_BRAIN_CHANGE)
    },
    undo: async ({ oldValue }: AddVideoActionValue) => {
      const { node, activeUuid, ivNodes, ivAst } = oldValue
      if (ivNodes) {
        const currentSceneNode =
          store.state.workspace.sceneManager.currentSceneNode
        currentSceneNode.removeChildren()
        ivNodes.forEach((node) => {
          currentSceneNode.addChild(node)
        })
        const ped = editorScript.getScript(currentSceneNode) as EditorDataScript
        ped.vpAst = _.cloneDeep(ivAst)
      }

      node.removeSelf()
      // 视频特殊处理
      const videoScriptConfig = videoScript.getScript(node)
      if (videoScriptConfig) {
        _.isFunction(videoScriptConfig.onDisable) &&
          videoScriptConfig.onDisable()
      }
      store.dispatch('workspace/game/video/setVideosManager')

      // 如果undo的时候记录了要激活的节点，则激活该节点
      const activeNode = findByUuid(activeUuid)
      if (activeNode) {
        store.dispatch('workspace/game/updateActiveNode', {
          node: activeNode,
          record: false,
        })
      } else {
        store.dispatch('workspace/game/clearActiveNode', {
          record: false,
        })
      }
      EventBus.$emit(Event.IV_BRAIN_CHANGE)
    },
    value,
    methodName: 'getAddVideoAction',
  }
}

export type SetVideoAttrs = {
  newValue: {
    attrs: Record<string, any>
  }
  oldValue: {
    attrs: Record<string, any>
  }
}
export const getSetVideoAttrs = (value: SetVideoAttrs) => {
  const videoModule = store.state.workspace.game.video
  const update = (attrs: Record<string, any>): void => {
    attrs.forEach((item: any) => {
      const targetNode = item.node as qc.Node
      if (!videoModule.videos[targetNode.uuid]) {
        videoModule.videos[targetNode.uuid] = videoScript.getScript(
          targetNode,
        ) as VideoScript
      }
      // @ts-ignore 自己保证传参类型
      videoModule.videos[targetNode.uuid][item.key] = item.value
    })
  }
  return {
    execute: ({ newValue }: SetVideoAttrs) => {
      update(newValue.attrs)
    },
    undo: ({ oldValue }: SetVideoAttrs) => {
      update(oldValue.attrs)
    },
    value,
    methodName: 'getSetVideoAttrsAction',
  }
}
